<!--
 * @Description: 页脚
-->
<template>
  <div class="footer">
    <div class="copyright">
      {{ copyright }}
    </div>
    <div class="version">
      {{ version }}
    </div>
  </div>
</template>

<script>
import config from '@/../package.json'
import { useI18n } from 'vue-i18n'
export default {
  setup() {
    const { t } = useI18n()
    const copyright = config.copyright
    const version = config.version
    return {
      t,
      copyright,
      version
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  height: 30px;
  margin-top: -30px;
  overflow: hidden;
  position: relative;
  background: #fff;
  color: #909399;
  z-index: 1002;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 5px 30px;
}
.copyright {
  float: left;
}
.version {
  float: right;
}
@media (max-width: 768px) {
  .footer {
    height: 30px;
    margin-top: -30px;
    overflow: hidden;
    background: #fff;
    color: #909399;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    padding: 5px 30px;
  }
}
</style>
